/* yp-support-chat v1 (2026-10-09). Inline support chat for /pages/contact. No libraries. */
(() => {
  const root = document.getElementById('SupportChat');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const ep = root.dataset.endpoint;
  if (!ep) { root.closest('.ypsc-section, .shopify-section')?.setAttribute('hidden', ''); return; }
  const log = root.querySelector('.ypsc__log'), form = root.querySelector('.ypsc__form'),
    input = root.querySelector('.ypsc__in'), send = root.querySelector('.ypsc__send'), chips = root.querySelector('.ypsc__chips');
  const KEY = 'ypsc_v1', MAX = 600;
  let hist = [];
  try { hist = JSON.parse(sessionStorage.getItem(KEY) || '[]').filter(m => m && m.role && m.content).slice(-12); } catch (e) {}
  let busy = false;

  const esc = s => s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const okUrl = u => /^https:\/\/[^\s"<>]+$/.test(u);
  function inline(t) {
    t = esc(t);
    t = t.replace(/\[([^\]]{1,120})\]\(((?:https:\/\/|mailto:)[^\s)]+)\)/g, (m, a, u) => (a = a.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, ''), okUrl(u)) ? `<a href="${u}"${/^https:\/\/([\w-]+\.)?ypresets\.com/.test(u) ? '' : ' target="_blank" rel="noopener"'}>${a}</a>` : /^mailto:[^\s"<>]+$/.test(u) ? `<a href="${u}">${a}</a>` : a);
    t = t.replace(/(^|[\s(])([\w.+-]+@ypresets\.com)\b/g, (m, p, e) => `${p}<a href="mailto:${e}">${e}</a>`);
    t = t.replace(/(^|[\s(])(https:\/\/[^\s<)]+[^\s<).,!?])/g, (m, p, u) => `${p}<a href="${u}">${u.replace(/^https:\/\/(www\.)?/, '').replace(/\/$/, '')}</a>`);
    return t.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }
  function md(text) {
    const out = []; let list = null, tag = 'ul';
    const flush = () => { if (list) { out.push(`<${tag}>${list.join('')}</${tag}>`); list = null; } };
    for (const raw of String(text).split('\n')) {
      const line = raw.trim();
      const li = line.match(/^([-*•]|\d+[.)])\s+(.*)/);
      if (li) { const tg = /\d/.test(li[1]) ? 'ol' : 'ul'; if (list && tg !== tag) flush(); tag = tg; (list = list || []).push(`<li>${inline(li[2])}</li>`); continue; }
      flush();
      if (line) out.push(`<p>${inline(line)}</p>`);
    }
    flush();
    return out.join('');
  }
  function bubble(role, content) {
    const li = document.createElement('li');
    li.className = 'ypsc__m ypsc__m--' + (role === 'user' ? 'me' : 'bot');
    if (role === 'user') li.textContent = content; else li.innerHTML = md(content);
    log.appendChild(li); log.scrollTop = log.scrollHeight;
    return li;
  }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(hist.slice(-12))); } catch (e) {} }
  function sync() { send.disabled = busy || !input.value.trim(); chips.hidden = hist.length > 0; }
  function grow() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 120) + 'px'; }

  bubble('assistant', root.dataset.greeting || 'Hi! What can I help you with?');
  hist.forEach(m => bubble(m.role, m.content));
  sync();

  async function ask(q) {
    q = q.trim().slice(0, MAX);
    if (!q || busy) return;
    busy = true; input.value = ''; grow();
    hist.push({ role: 'user', content: q }); bubble('user', q); sync(); save();
    const t = document.createElement('li'); t.className = 'ypsc__m ypsc__m--bot'; t.setAttribute('aria-label', 'Typing');
    t.innerHTML = '<span class="ypsc__typing"><i></i><i></i><i></i></span>'; log.appendChild(t); log.scrollTop = log.scrollHeight;
    let reply;
    try {
      const ctl = new AbortController(); const to = setTimeout(() => ctl.abort(), 30000);
      const r = await fetch(ep, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: hist.slice(-12) }), signal: ctl.signal });
      clearTimeout(to);
      const d = await r.json().catch(() => ({}));
      reply = d.reply;
    } catch (e) {}
    t.remove();
    reply = reply || root.dataset.error;
    hist.push({ role: 'assistant', content: reply }); bubble('assistant', reply); save();
    busy = false; sync();
    if (matchMedia('(hover:hover)').matches) input.focus();
  }

  form.addEventListener('submit', e => { e.preventDefault(); ask(input.value); });
  input.addEventListener('input', () => { grow(); sync(); });
  input.addEventListener('keydown', e => { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); ask(input.value); } });
  chips.addEventListener('click', e => { const b = e.target.closest('.ypsc__chip'); if (b) ask(b.textContent); });
})();
